import axios from '@/assets/js/axios.js'
import { MODEL_SERVICE_API } from './apis'
// 菜单列表

export function list (params) {
  return axios({
    url: MODEL_SERVICE_API.MENU_LIST,
    method: 'post',
    data: params
  })
}
// 添加菜单
export function addMenu (params) {
  return axios({
    url: MODEL_SERVICE_API.ADD_MENU,
    method: 'post',
    data: params
  })
}
// 修改用户信息
export function editMenu (params) {
  return axios({
    url: MODEL_SERVICE_API.ADD_MENU,
    method: 'put',
    data: params
  })
}
// 删除用户信息
export function deleteMenu (params) {
  return axios({
    url: MODEL_SERVICE_API.ADD_MENU + '/' + params,
    method: 'DELETE'
  })
}
// 根据id获取对应的数据
export function menuForId (params) {
  return axios({
    url: MODEL_SERVICE_API.ADD_MENU + '/' + params,
    method: 'get'
  })
}
// 选择父级菜单
export function listOwnerMenu (params) {
  return axios({
    url: MODEL_SERVICE_API.OWNER_MENU_LIST,
    method: 'get'
  })
}
// 分配菜单权限
export function bindAccess (params) {
  return axios({
    url: MODEL_SERVICE_API.MENU_BIND_ACCESS,
    method: 'POST',
    data: params
  })
}
